import React from 'react';
import Modal from 'react-responsive-modal';
import Button from '../inputs/Button';
import StillThereSvg from '../../assets/svg/still-there.svg';

const UnauthorizedModal = ({
  open,
  onReLogin = () => {},
  title = 'Session Verification Required',
  body = 'We are unable to verify your session right now. Please sign in again to continue using the platform.'
}) => {
  return (
    <Modal
      classNames={{
        modal: 'rounded-sm'
      }}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      open={open}
      onClose={() => {}}
      center
      showCloseIcon={false}
    >
      <div className="w-full max-w-96 flex flex-col items-center p-5">
        <div className="py-2">
          <img src={StillThereSvg} alt="Session issue" className="w-32 h-32" />
        </div>
        <div className="flex flex-col items-center gap-2 py-2 pb-4 text-center">
          <p className="font-semibold text-lg">{title}</p>
          <p className="text-[#808080] text-base">{body}</p>
        </div>

        <div className="flex flex-col items-center gap-2 py-2 pb-4 text-center">
          <p className="text-[#808080] text-sm">
            Or contact support{' '}
            <a
              href="mailto:helpdesk@alatpay.ng"
              className="text-alat-light font-semibold"
            >
              helpdesk@alatpay.ng
            </a>
          </p>
        </div>

        <Button
          label="Sign in again"
          onClick={onReLogin}
          className="w-full mt-auto max-w-52"
        />
      </div>
    </Modal>
  );
};

export default UnauthorizedModal;
